/**
 * Вычисляет сезон из даты
 * @param {string} dateStr - дата в формате YYYY-MM-DD
 * @returns {string} - сезон в формате "Весна 2025", "Лето 2025", "Осень 2025", "Зима 2025"
 */
export const getSeasonFromDate = (dateStr) => {
    if (!dateStr) return 'Без сезона';
    const date = new Date(dateStr);
    const month = date.getMonth();
    const year = date.getFullYear();

    if (month >= 2 && month <= 4) return `Весна ${year}`;
    if (month >= 5 && month <= 7) return `Лето ${year}`;
    if (month >= 8 && month <= 10) return `Осень ${year}`;
    // Зима: декабрь предыдущего года относится к зиме следующего года
    // Декабрь 2025 → Зима 2026, Январь/Февраль 2026 → Зима 2026
    return `Зима ${month === 11 ? year + 1 : year}`;
};
